/**
 * contact-form.js — client-side spam guard for the contact section.
 * Blocks a submit when the hidden honeypot is filled (bots fill every field)
 * or when the form is submitted implausibly fast (< 2s = automated). Real
 * visitors, who type a name/email/message, never trip either check.
 */
document.querySelectorAll('.contact__form').forEach((form) => {
  const loadedAt = Date.now();
  form.addEventListener('submit', (event) => {
    const honeypot = form.querySelector('.contact__hp input');
    const tooFast = Date.now() - loadedAt < 2000;
    if ((honeypot && honeypot.value.trim() !== '') || tooFast) {
      event.preventDefault();
      event.stopPropagation();
    }
  });
});
